import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var CircleIcon = createIcon({
  displayName: 'CircleIcon',
  viewBox: '0 0 24 24',
  path: /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "currentColor",
    r: "12"
  })
});
//# sourceMappingURL=Circle.js.map